<div class="modal-header">
  <h5 class="modal-title">{{ filme.titulo }}</h5>
  <button type="button" class="btn-close" (click)="activeModal.dismiss()"></button>
</div>

<div class="modal-body">
  @if (filme.imagemGrande) {
    <img [src]="getImagemUrl(filme.imagemGrande)" class="filme-imagem-grande mb-3" alt="{{ filme.titulo }}">
  }

  <div class="mb-2">
    <div class="d-flex align-items-center gap-2">
      <h4 class="mb-0">{{ filme.titulo }}</h4>
      <span class="badge text-bg-secondary">{{ filme.anoLancamento }}</span>
    </div>
    @if (filme.tituloOriginal) {
      <p class="filme-titulo-original mb-0"><strong>Título Original:</strong> {{ filme.tituloOriginal }}</p>
    }
    @if (filme.avaliacao) {
      <app-star-rating [value]="filme.avaliacao" class="d-block mt-1"></app-star-rating>
    }
  </div>

  @if (filme.direcao) {
    <p class="text-muted mb-2"><strong>Direção:</strong> {{ filme.direcao }}</p>
  }

  @if (elencoTags.length > 0) {
    <div class="mb-3 elenco-tags">
      @for (ator of elencoTags; track ator) {
        <span class="badge rounded-pill text-bg-light border me-1 mb-1">{{ ator }}</span>
      }
    </div>
  }

  <p class="filme-descricao">{{ filme.descricao || filme.descricaoCurta }}</p>
</div>
